/**
 * Open new window
 * @param url
 * @param target
 */
export const openWindow = (url, target) => {
	if (typeof window.open !== 'undefined') {
		window.open(url, target);
	} else {
		// window.location.href = url;
		safeRedirect(url);
	}

	// safari redirect
	if (isIosSafari()) {
		// window.location.href = url;
		// window.location.assign(url);
		safeRedirect(url);
	}
};


/**
 * Safe redirect
 * @param url
 */
export const safeRedirect = url => {
	// location = url;
	window.location.href = url;
	return false;
};

/**
 * Check if is iOS safari.
 * @return {boolean}
 */
export const isIosSafari = () => {
	let ua = window.navigator.userAgent;
	let iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
	let webkit = !!ua.match(/WebKit/i);
	return iOS && webkit && !ua.match(/CriOS/i);
};


export const isMobile = () => {
	return $(window).width() < 750;
};
